import fr from 'facet-rest';
import LabeledSwitch from 'Components/UI/LabeledSwitch';
import { withStyles } from '@material-ui/styles';
import SelectControl from 'Components/UI/SelectControl';
import RichTextWithHelper from 'Components/UI/RichTextEditor/RichTextWithHelper';
import { NumberFormatUsd } from 'Components/UI/MaskedInput';

const StyledSelect = withStyles({
  root: {
    marginTop: 0,
  },
})(SelectControl);
const overrideAccordionAttributes = (override) => {
  return override
    .nameOverride('type', {
      _hideLabel: true,
      _customProps: {},
      _component: StyledSelect,
    })
    .nameOverride('institution', {
      hidden: false,
      _hideLabel: true,
      _customProps: {
        InputProps: { style: { marginTop: 0 } },
        style: { fontSize: 12 },
      },
    })
    .nameOverride('name', {
      hidden: false,
      _hideLabel: true,
      _customProps: {
        InputProps: { style: { marginTop: 0 } },
        style: { fontSize: 12 },
      },
    })
    .nameOverride('notes', {
      hidden: false,
      _hideLabel: true,
      _component: () => RichTextWithHelper,
      _customProps: {
        InputProps: { style: { marginTop: 0 } },
        style: { fontSize: 12 },
      },
    })
    .nameOverride('notes', {
      hidden: false,
      _hideLabel: true,
      _customProps: {
        InputProps: { style: { marginTop: 0 } },
        style: { fontSize: 12 },
      },
    })
    .nameOverride('hasBeneficiary', {
      hidden: false,
      _component: () => LabeledSwitch,
    })
    .nameOverride('balance', {
      hidden: false,
      _hideLabel: true,
      _customProps: {
        InputProps: {
          inputComponent: NumberFormatUsd,
        },
        style: { fontSize: 12 },
      },
    });
};

const PlannerDataTabAccountOverride = fr.metaOverride();
export default overrideAccordionAttributes(PlannerDataTabAccountOverride);
